import React, { useMemo } from 'react';
import { List } from "antd";
import withAntDPagination from "./higherOrderComponents/withAntDPagination";

const ListAntD = (props) => {
    const { data = [], showBackgroundOnHover = true, removeListPadding = false, pagingData = null, pagingDependencies, loading = false, disableTabbing= false, noDataMessage = 'No results found', ...rest } = props;

    if (pagingData !== null) {

        if (!pagingData.fetchFunction) {
            console.error('AntD pagingData requires a valid fetchFunction as a parameter.');
            return null;
        }

        if (typeof pagingData.fetchFunction !== 'function') {
            console.error('AntD pagingData fetchFunction must be a function.');
            return null;
        }

        if (pagingData.params === undefined) {
            console.warn('Warning: pagingData.params is undefined.');
        }

        const PagedList = useMemo(() =>
                withAntDPagination(List, pagingData.fetchFunction, pagingData.params)
            , Array.isArray(pagingDependencies) ? pagingDependencies : []);

        const addRoleToRenderItem = (item, index) => (
            <List.Item role="listitem" style={removeListPadding?{padding:0,margin:0}:{}} tabIndex={disableTabbing ? -1: 0} className={'ch-list-item'+(showBackgroundOnHover?' ch-bg-hover-highlight':' no-bottom-border')}>
                {props.renderItem ? props.renderItem(item, index) : item}
            </List.Item>
        );

        return (
            <PagedList
                className={'ch-general-list-antd'}
                size={'small'}
                tabIndex={disableTabbing ? -1 : 0}
                role="list"
                {...rest}
                renderItem={addRoleToRenderItem}
                loading={loading}
                locale={{ emptyText: typeof noDataMessage === 'string'?<span className="ch-warning-text">{noDataMessage}</span>:noDataMessage}}
            />
        );
    }

    return (
        <List size={'small'} renderItem={addRoleToRenderItem} role="list" tabIndex={disableTabbing ? -1 : 0} {...rest} />
    );
};

export default ListAntD;